// @flow
import JQueryView, { on, removeInvalidFeedback } from '../../common/JQueryView';
import SearchAddressForm from '../../common/SearchAddressForm';

declare var $: any;

export default class FormView extends JQueryView {
  searchAddress: Object;

  constructor() {
    super('.simple_form');
    this.searchAddress = new SearchAddressForm('.simple_form');
  }

  @on({ event: 'change', selector: '.form-control' })
  onChangeFormControl(event: any) {
    const target = $(event.target);
    if (target.val().length !== 0) {
      target.find('.form-control').addClass('form-control-active');
      target.removeClass('is-invalid');
      removeInvalidFeedback(target);
      target.removeClass('focus');
    }
  }

  @on({ event: 'blur input', selector: '.form-group-float, .form-control' })
  onBlurFormControl(event: any) {
    const target = $(event.target);
    if (target.hasClass('date-field1') && $('.show-calendar').is(':visible')) {
      target.addClass('form-control-active');
      target.addClass('focus');
    } else {
      if (target.val().length === 0) {
        target.removeClass('form-control-active');
      } else {
        target.addClass('form-control-active');
        target.removeClass('is-invalid');
        removeInvalidFeedback(target);
      }
    }
  }

  @on({ event: 'click' })
  onClickOtherArea(event: any) {
    if (!$(event.target).closest('.date-field1').length) {
      $('.date-field1').removeClass('focus');

      if ($('.date-field1').val().length === 0) {
        $('.date-field1').removeClass('form-control-active');
      }
    }
  }
}
